<template>
  <div class="modalback">
    <div class="modalcontent container">
      <div class="row justify-content-center align-items-center" style="height:120px">
          <div class="col">
              <p class="text-light">未編集項目があります</p>
          </div>
      </div>
      <div class="row justify-content-center">
          <div class="col">
              <button class="btn btn-light" @click="closeAction">いいえ</button>
          </div>
          <div class="col">
              <button class="btn btn-primary" @click="okAction">はい</button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: "AddCartDialog",
  props: {},
  data: function () {
    return {
    };
  },
  mounted: function () {
    // 画面の遷移があるか調べる
  },
  methods: {
      async okAction(){
        await this.$store.state.addCartDialogCallback();
        this.$store.commit("setAddCartDialog", {isShow:false, callback:()=>{}});
      },
      closeAction(){
        this.$store.commit("setAddCartDialog", {isShow:false, callback:()=>{}});
      }
  },
  components: {
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalback {
  z-index: 200;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  z-index: 201;
  width: 300px;
  height: 200px;
  padding: 1em;
  background-color: rgb(85, 82, 82);
  border: 3px solid rgb(215, 215, 215);
}
</style>
